export default {
  methods: {
    isAdmin() {
      return this.$auth.check([1]);
    }
  }
};
